// engine/csvHelpers.js
export const parseCSV = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split(/\r\n|\n/).filter(Boolean);

      if (!lines.length) return reject(new Error("Empty CSV"));

      const headers = lines[0].split(",").map(h => h.trim());
      const rows = lines.slice(1).map(line => line.split(",").map(cell => cell.trim()));

      resolve({ headers, rows });
    };

    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
};

export const buildTableUnitFromCSV = ({ headers, rows }) => {
  // Build CVL (column definitions)
  const cvl = headers.map(header => {
    // Auto-detect type (basic: number, select, text)
    if (header.toLowerCase().includes("status")) {
      return {
        name: header,
        type: "select",
        options: [
          { label: "Open", value: "open" },
          { label: "Closed", value: "closed" }
        ]
      };
    }
    if (header.toLowerCase().includes("amount") || header.toLowerCase().includes("age")) {
      return { name: header, type: "number", agg: "sum" };
    }
    return { name: header, type: "text" };
  });

  // Add an Actions column at start
  cvl.unshift({ name: "Actions", type: "buttonList" });

  // Add sequence column after actions
  cvl.splice(1, 0, { name: "Seq", type: "sequence" });

  // Build data: add Actions and Seq placeholders
  const data = rows.map((row, idx) => {
    return [
      ["edit", "add", "attach"], // Actions
      idx + 1,                   // Seq
      ...row                      // Original CSV cells
    ];
  });

  return {
    id: `table_${Date.now()}`,
    type: "table",
    cvl,
    data
  };
};
